import React from "react";
import { Link } from "react-router-dom";
import AdminNavbar from "./AdminNavbar";
import TeacherNavbar from "./TeacherNavbar";
import StudentNavbar from "./StudentNavbar";
import "./Navbar.css";
import HomeNavbar from "./HomeNavbar";
import logo from "../../assets/loginlogo.jpg";

function Navbar({ user, handleLogout, handleProfile }) {
  // if (!user) return null;

  // if (!user) {
  //   return <HomeNavbar />;
  // }

  return (
    <nav className="main-navbar">
      <div className="navbar-brand" >
        <Link to="/">
        <img src={logo} alt="Institute Logo" height="30px" width="30px" style={{borderRadius : "100%"}} />
        <span>PITMANSTENO</span>
        </Link>
      </div>

      {user && (
        <>
          <div className="navbar-links">
            {user?.role === "admin" && <AdminNavbar />}
            {user?.role === "teacher" && <TeacherNavbar />}
            {user?.role === "student" && <StudentNavbar />}
          </div>
          <div className="navbar-user">
            <span className="user-greeting" onClick={handleProfile}>
              Hello, {user.username}
            </span>
            <button onClick={handleLogout} className="logout-button">
              Logout
            </button>
          </div>
        </>
      )}

      {!user && (
        <div className="navbar-user">
          <Link to="/login" className="login-link">
            <button className="logout-button">Login</button>
          </Link>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
